import script from "./WorkSpaceDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkSpaceDashboard.vue?vue&type=script&setup=true&lang=js"

import "./WorkSpaceDashboard.vue?vue&type=style&index=0&id=4b0d2fb3&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b0d2fb3"]])

export default __exports__